import './TemplateContainer.scss';

import { Trans, useTranslation } from 'react-i18next';

import DownloadBar from 'components/DownloadBar/DownloadBar';
import Paragraph from 'components/TextComps/Paragraph';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const TemplateContainer = observer(() => {
  const { t } = useTranslation();
  const iss = useStores().inviteStudentsStore;

  return (
    <div className='step template-container'>
      <Paragraph>
        <Trans i18nKey='Step1PrepareStudentList' ns='studentsPage'>
          <strong>Step 1</strong> Prepare student list using template
        </Trans>
      </Paragraph>
      <DownloadBar
        subtitle={t('StudentList', { ns: 'studentsPage' })}
        description={t('DownloadTemplateHere', { ns: 'studentsPage' })}
        iconSubtitle={t('CSV', { ns: 'studentsPage' })}
        onClick={() => iss.downloadTemplate()}
      />
    </div>
  );
});

export default TemplateContainer;
